// extracted by mini-css-extract-plugin
module.exports = {"login-background":"ForgotPassword_login-background__17Hv7"};